import { useTranslation } from 'react-i18next'
import { Avatar } from '@/components/ui/avatar'
import { Table, TBody, TD, TH, THead, TR } from '@/components/ui/table'
import { fmtMoney } from '@/features/shared/format'
import type { BordroSatir } from '../../types'
import { MobileList } from '../MobileList'
import { BordroStatusPill } from '../StatusPill'
import { TABLE_FRAME } from '../tableFrame'
import { BordroRowActions } from './BordroRowActions'

export function BordroTable({
  rows,
  donem,
  selectedId,
  onSelect,
  onSummary,
}: {
  rows: BordroSatir[]
  donem: string
  selectedId: string | null
  onSelect: (id: string) => void
  onSummary: (id: string) => void
}) {
  const { t } = useTranslation()
  if (rows.length === 0) return <div className="px-5 py-14 text-center text-sm text-muted-foreground">{t('hr.personel.empty')}</div>

  return (
    <>
      <MobileList
        rows={rows.map((r) => ({
          key: r.id,
          leading: <Avatar name={r.ad} className="size-9" />,
          title: r.ad,
          subtitle: `${r.unvan} · ${r.departman}`,
          trailing: <BordroStatusPill durum={r.durum} />,
          meta: (
            <span>
              {t('hr.personel.ucret.net')}: <span className="font-medium tabular-nums text-foreground">{fmtMoney(r.net)}</span>
            </span>
          ),
          selected: selectedId === r.id,
          onClick: () => onSummary(r.id),
        }))}
      />
      <Table className="hr-table" wrapperClassName={TABLE_FRAME}>
        <THead>
          <TR>
            <TH>{t('hr.personel.columns.personel')}</TH>
            <TH>{t('hr.personel.columns.departman')}</TH>
            <TH className="text-right">{t('hr.personel.ucret.brut')}</TH>
            <TH className="text-right">{t('hr.personel.bordro.ek')}</TH>
            <TH className="text-right">{t('hr.personel.ucret.kesintiler')}</TH>
            <TH className="text-right">{t('hr.personel.ucret.net')}</TH>
            <TH>{t('hr.personel.columns.durum')}</TH>
            <TH className="w-10" />
          </TR>
        </THead>
        <TBody>
          {rows.map((r) => (
            <TR key={r.id} data-selected={selectedId === r.id ? 'true' : undefined} className="cursor-pointer" onClick={() => onSelect(r.id)}>
              <TD>
                <div className="flex items-center gap-3">
                  <Avatar name={r.ad} />
                  <div className="min-w-0">
                    <div className="truncate font-medium">{r.ad}</div>
                    <div className="truncate text-xs text-muted-foreground">{r.unvan}</div>
                  </div>
                </div>
              </TD>
              <TD className="text-muted-foreground">{r.departman}</TD>
              <TD className="text-right tabular-nums">{fmtMoney(r.brut)}</TD>
              <TD className="text-right tabular-nums">{fmtMoney(r.ek)}</TD>
              <TD className="text-right tabular-nums">{fmtMoney(r.kesinti)}</TD>
              <TD className="text-right font-semibold tabular-nums">{fmtMoney(r.net)}</TD>
              <TD>
                <BordroStatusPill durum={r.durum} />
              </TD>
              <TD>
                <BordroRowActions row={r} donem={donem} onSummary={() => onSummary(r.id)} />
              </TD>
            </TR>
          ))}
        </TBody>
      </Table>
    </>
  )
}
